import { FC } from "react";
import cn from "classnames";

type PassengerGenderOption = { value: string; label: string };

type PassengerGenderFieldProps = {
  value?: string;
  onChange?: (value: string) => void;
  options: PassengerGenderOption[];
};

const PassengerGenderField: FC<PassengerGenderFieldProps> = ({ value, onChange, options }) => {
  return (
    <div className="flex w-full gap-3">
      {options.map((option) => {
        const isSelected = option.value === value;
        return (
          <button
            key={option.value}
            onClick={() => onChange?.(option.value)}
            className={cn(
              "flex flex-1 cursor-pointer items-center justify-center rounded-xs border border-current p-2 font-semibold transition-colors duration-200 hover:text-font-active",
              isSelected
                ? "text-font-active bg-icon-active/10"
                : "text-font-minimal",
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default PassengerGenderField;
